import { blobMediaUrl } from "@/lib/blob-url"

/* ───────────────────── MRI package catalogue ─────────────────────
 * The full-body-MRI package tiers (Core/Advanced/Pro). Pure catalogue data
 * with no client-only dependencies, so both the client `MriPackageCards`
 * component and the server test/pricing pages can read it — the latter build
 * their Product/Offer JSON-LD from it, which needs `image` for Google Merchant
 * listings. Lived in the "use client" mri-package-cards.tsx before; a server
 * component importing a value from a client module gets a client reference,
 * not the array, so the data has to sit in a server-safe module. */
export const MRI_PACKAGES = [
  {
    name: "Core",
    duration: "45 min",
    descriptionKey: "pkgCoreDescription" as const,
    // Member rate, mirrors MEMBER_PRICING_ITEMS on the membership page (the
    // catalog source of truth). CHF-only.
    memberPrice: "1890",
    priceKey: "core",
    ctaKey: "bookCore" as const,
    includesLabelKey: "pkgCoreIncludesLabel" as const,
    bookingId: "3b7895a5-b892-44f9-9175-c2f7fd8e7962",
    features: [
      { nameKey: "featureFullBodyMri" as const, ai: false },
      { nameKey: "featureBrainMri" as const, ai: false },
      { nameKey: "featureSpineMri" as const, ai: false },
    ],
    image: blobMediaUrl("/images/products/package-core.png"),
    variant: "green" as const,
    highlighted: false,
  },
  {
    name: "Advanced",
    duration: "60 min",
    descriptionKey: "pkgAdvancedDescription" as const,
    memberPrice: "2290", // mirrors the membership catalog
    priceKey: "advanced",
    ctaKey: "bookAdvanced" as const,
    includesLabelKey: "pkgAdvancedIncludesLabel" as const,
    bookingId: "5147c324-1776-4e0a-9cc4-cff5bbcb18c0",
    features: [
      { nameKey: "featureAdvancedBloodTest" as const, ai: false },
      { nameKey: "featureBodyComposition" as const, ai: true },
      { nameKey: "featureProstateOvariesMri" as const, ai: false },
    ],
    image: blobMediaUrl("/images/products/package-advanced.png"),
    variant: "blue" as const,
    highlighted: false,
    mostPopular: true,
  },
  {
    name: "Pro",
    duration: "80 min",
    descriptionKey: "pkgProDescription" as const,
    memberPrice: "3290", // mirrors the membership catalog
    priceKey: "pro",
    ctaKey: "bookPro" as const,
    includesLabelKey: "pkgProIncludesLabel" as const,
    bookingId: "64c6c5cb-95c4-4310-b8b5-ff68abfe7b38",
    features: [
      { nameKey: "featureBrainVolumetry" as const, ai: true },
      { nameKey: "featureHipsKneesMri" as const, ai: false },
      { nameKey: "featureHormonesVitamins" as const, ai: false },
    ],
    image: blobMediaUrl("/images/products/package-pro.png"),
    variant: "pink" as const,
    highlighted: false,
  },
]
